import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/_app/developer')({
  staticData: {
    breadCrumb: 'Developer',
  },
});
